import { PublicPage } from 'api/website';
import { isDefined } from 'utils/functional';

type Props = {
  content: PublicPage;
};

export function getContentWithBanner({ content }: Props) {
  return isDefined(content.heroSearch);
}
